module.exports = __webpack_public_path__ + "38448c25fe1e4a3a97f2f8af9c3c1901.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/jogo-do-bicho/surpresinha.png
// module id = 1042
// module chunks = 0